import {
    order_store_request_invalid,
    order_store_request_send,
    order_store_request_valid
} from './../actions/store'
import {constSend, constInvalid, constValid, constInitialStateRequest} from "../../../constants";

const initialState = {
    storeData: constInitialStateRequest(),
};

export const orderReducer = function (state = initialState, action) {
    switch (action.type) {
        case order_store_request_invalid: {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    ...constInvalid(),
                },
            };
        }
        case order_store_request_send: {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    ...constSend(),
                },
            };
        }
        case order_store_request_valid: {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    ...constValid(),
                    response: action.data,
                },
            };
        }
        default:
            return state;
    }
};